import { render, staticRenderFns } from "./reporteCobranza.vue?vue&type=template&id=50844170"
import script from "./reporteCobranza.vue?vue&type=script&lang=js"
export * from "./reporteCobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports